/**
 * Normaliza valores de erro de try/catch ou APIs para string (ex.: alertas).
 */
export function getErrorMessage(
    error: unknown,
    fallback = 'Ocorreu um erro.'
): string {
    if (error instanceof Error) {
        return error.message;
    }
    if (
        typeof error === 'object' &&
        error !== null &&
        'message' in error
    ) {
        return String((error as { message: unknown }).message);
    }
    return fallback;
}
